import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=d9f92262"
import script from "./Sidebar.js?vue&type=script&lang=js&external"
export * from "./Sidebar.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports